// CAPACITY CHART - ADD BTN TO INTRO CONTENT
const introCopy = document.querySelector('.intro-content__text');
const chartBtn = introCopy ? introCopy.querySelector('.btn[href^="#capacity-chart-"]') : false;

if (introCopy && !chartBtn) {
	document.querySelectorAll('.capacity-chart').forEach(mod => {
		introCopy.insertAdjacentHTML('beforeend', `<a data-fromjs class="btn" href="#${mod.getAttribute('id')}">See Capacity Chart</a>`);
	});
}

// LANG TOGGLE
document.querySelectorAll('.header__lang').forEach(langMod => {
	langMod.querySelector('span').addEventListener('click', () => {
		langMod.classList.toggle('active');
		
	});
});

// TOGGLE MAIN NAV TABLET
document.querySelectorAll('[data-toggle_nav]').forEach((btn) => {
    if (document.querySelector('.header__nav')) {
        btn.addEventListener('click', (e) => {
            document.querySelector('.header__nav').classList.toggle('active');
        });
    }
});

// OPEN MAIN NAV MOBILE
document.querySelectorAll('[data-toggle_nav_m], .close-menu').forEach((btn) => {
	console.log('entra click');
    if (document.querySelector('.navigation')) {
        btn.addEventListener('click', (e) => {
            document.querySelector('.navigation').classList.toggle('active');
            document.body.classList.toggle('no-scroll', document.querySelector('.navigation').classList.contains('active'));
        });
    }
});

// TOGGLE MENUS
document.querySelectorAll('.js-menus-block').forEach((block) => {
	const btns = block.querySelectorAll('.js-menu-btn');

	let activeBtn = block.querySelector('.js-menu-btn.active');
	let activeMenu = block.querySelector(`.js-menu.active`);

	btns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();

			activeBtn.classList.remove('active');
			btn.classList.add('active');
			activeBtn = btn;

			activeMenu.classList.remove('active');
			activeMenu.classList.add('hidden');
			activeMenu = block.querySelector(`.js-menu[data-id="${btn.dataset.id}"]`);
			activeMenu.classList.remove('hidden');
			activeMenu.classList.add('active');
		});
	});
});

// ACCORDION
document.querySelectorAll("[data-accordion]").forEach((accordion) => {
	accordion.querySelectorAll("[data-accordion-head]").forEach((itemHead) => {
		itemHead.addEventListener("click", (e) => {
			const item = itemHead.closest("[data-accordion-item]");
			const itemBody = item.querySelector("[data-accordion-body]");

			accordion.querySelectorAll("[data-accordion-body]").forEach((body) => {
                if (itemBody !== body) {
                    body.slideUp(300, () => {
                        body.closest("[data-accordion-item]").classList.remove("active");
                    });
                }
            });

			itemBody.slideToggle(300, () => item.classList.toggle("active") );
		});
	});
});

window.addEventListener('load', function() {
// CUSTOM MODAL ICONS
const customLbx = new LBX('.js-lbx');
const customCloseIcon = document.getElementById("_fusion_icon-modalClose");
const customArrowIcon = document.getElementById("_fusion_icon-modalArrow");

if (customCloseIcon && customCloseIcon.innerHTML !== "") {
	customLbx.icons.close = customCloseIcon.innerHTML;
}
if (customArrowIcon && customArrowIcon.innerHTML !== "") {
	customLbx.icons.prev = customArrowIcon.innerHTML;
	customLbx.icons.next = customArrowIcon.innerHTML;
	customLbx.customClass = "modal_oneArrow";
}

// GALLERY TPL MODAL
const fullscreenLbx = new LBX('.js-lbx-fullscreen');
fullscreenLbx.fullScreen = true;
fullscreenLbx.wideArrows = false;

if (customCloseIcon && customCloseIcon.innerHTML !== "") {
	fullscreenLbx.icons.close = customCloseIcon.innerHTML;
}
if (customArrowIcon && customArrowIcon.innerHTML !== "") {
	fullscreenLbx.icons.prev = customArrowIcon.innerHTML;
	fullscreenLbx.icons.next = customArrowIcon.innerHTML;
	fullscreenLbx.customClass = "modal_oneArrow";
}
});

// EMBED VIDEO INTRO CONTENT MODAL

const customLBXEmbed = new LBX('.js-lbx-embed');


const customCloseIcon = document.getElementById("_fusion_icon-modalClose");
const customArrowIcon = document.getElementById("_fusion_icon-modalArrow");

if (customCloseIcon && customCloseIcon.innerHTML !== "") {
	customLBXEmbed.icons.close = customCloseIcon.innerHTML;
}
if (customArrowIcon && customArrowIcon.innerHTML !== "") {
	customLBXEmbed.icons.prev = customArrowIcon.innerHTML;
	customLBXEmbed.icons.next = customArrowIcon.innerHTML;
	customLBXEmbed.customClass = "modal_oneArrow";
}

// COLUMNS FILTER
document.querySelectorAll('.columns-block').forEach((block) => {

	let tabs_btn = document.querySelectorAll('button[data-tag]');
	
	tabs_btn.forEach((tag) => {
		tag.addEventListener("click", () => {
			
			let activeBtn = document.querySelector('button[data-tag].active')

			activeBtn.classList.remove('active');
			tag.classList.add('active');

			const filter_tag = tag.dataset.tag
			
			document.querySelectorAll('.columns-block [data-tagItem]').forEach((item)=>{
				if(item.dataset.tagitem.includes(filter_tag)){
					item.classList.remove("inactive")
				}else{
					item.classList.add("inactive")
				}
			})
		})
	})
	document.querySelector('button[data-tag]').click();
});
